module.exports = __webpack_public_path__ + "img/Contacto 576px.cf6fdd30.png";